import { render, staticRenderFns } from "./CmsLayoutResolver.vue?vue&type=template&id=dd146ce6"
import script from "./CmsLayoutResolver.vue?vue&type=script&lang=js"
export * from "./CmsLayoutResolver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports